import httpClient from './api/httpClient';

const END_POINT = 'campus';
export const getAllByChamada = (chamadaId) => httpClient.get(END_POINT + '/chamada/' + chamadaId);
export const getAllCursosByChamadaCampus = (chamadaId, campusId) => httpClient.get(END_POINT + '/' + chamadaId + '/' + campusId + '/cursos');

